export default function newWindowLinks() {
  const links = document.querySelectorAll('a[target="_blank"]');

  if (links.length === 0) return;

  const descriptionId = 'new-tab-description';

  links.forEach((link) => {
    const rel = link.getAttribute('rel') || '';
    if (!rel.includes('noopener')) {
      link.setAttribute('rel', `${rel} noopener noreferrer`.trim());
    }

    const ariaDescribedBy = link.getAttribute('aria-describedby');
    if (!ariaDescribedBy) {
      link.setAttribute('aria-describedby', descriptionId);
    } else if (!ariaDescribedBy.includes(descriptionId)) {
      link.setAttribute('aria-describedby', `${ariaDescribedBy} ${descriptionId}`);
    }
  });
}
